export default "__VITE_ASSET__Dh5r9m_f__"